import { DigitalToolsItem } from '~/shared/types/digitalTools.types'

export const digitalToolsItems: DigitalToolsItem[] = [
  {
    name: 'geogebra',
    icon: 'geogebra',
    path: '/geogebra',
    languages: ['no', 'en', 'uk'],
  },
  {
    name: 'excel',
    icon: 'excel',
    path: '/excel',
    languages: ['no', 'en', 'uk'],
  },
]
